export const autoUrlProtocolComponentModule = angular
  .module('Q.components.forms.auto-url-protocol', [])
  .directive('autoUrlProtocol', function () {
    return {
      require: 'ngModel',
      link: function (scope, el, attrs, ngModel) {
        ngModel.$parsers.push(function (v) {
          if (v.length && !/^[a-z]+:/.test(v)) {
            v = 'http://' + v;
          }
          return v;
        });
      },
    };
  });
